import React, { useState, useCallback, useEffect } from 'react'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { useVestigioService } from 'hooks/useVestigioService'
import { TextField, Checkbox, CircularProgress, InputAdornment } from '@material-ui/core'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import SearchIcon from '@material-ui/icons/Search'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import useRouter from 'utils/useRouter'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export const SelectVestigio = (props) => {
  const vestigioService = useVestigioService()
  const [processandoVestigios, setProcessandoVestigios] = useState(false)
  const { vestigiosExternos, setVestigiosExternos, searchIcon, size, setProcessandoImportarVestigio, tamanhoTextoPesquisa, label, multiplo, idCaso } = props
  const [listaOpcoesVestigiosFiltros, setListaOpcoesVestigiosFiltros] = useState([])
  const [inputVestigio, setInputVestigio] = useState(null)

  const fetchVestigios = useCallback(async (valor) => {
    setProcessandoVestigios(true)
    const exclude =  idCaso ? await vestigioService.listarVestigiosDeCasoAsync(idCaso, setProcessandoImportarVestigio) : []
    const response = await vestigioService.listarVestigiosPorIdentificadorLikeString(valor)
    const filteredResponse = response.filter((vestigio) => !exclude.some((excluido) => excluido.id === vestigio.id))
    setListaOpcoesVestigiosFiltros(filteredResponse)
    setProcessandoVestigios(false)
  }, [idCaso])

  const handleChangeInputVestigio = useCallback(
    (value) => {
      setInputVestigio(value)

      if (value?.length > 4) {
        fetchVestigios(value)
      } else {
        setListaOpcoesVestigiosFiltros([])
      }
    },
    [fetchVestigios]
  )

  return (
    <AutocompleteNative
      value={vestigiosExternos}
      multiple={multiplo}
      size={size}
      name="vestigio"
      noOptionsText="Sem informações"
      options={listaOpcoesVestigiosFiltros || []}
      onChange={(event, newValue) => {
        setVestigiosExternos(newValue)
      }}
      getOptionSelected={(option, value) => option?.id === value?.id}
      getOptionLabel={(option) => `${option?.identificador?.toUpperCase()}`}
      renderOption={(option, { selected }) => (
        <>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{
              marginRight: 8,
            }}
            checked={selected}
          />
          {option?.identificador?.toUpperCase()}
        </>
      )}
      loading={processandoVestigios}
      loadingText="Carregando..."
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          placeholder={searchIcon ? 'Pesquisar...' : ''}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={(e) => {
            let valor = e.target.value.toUpperCase()

            if (!valor.startsWith('VG-')) {
              valor = 'VG-' + valor.replace(/^VG-?/i, '')
            }

            handleChangeInputVestigio(valor)
          }}
        />
      )}
    />
  )
}
